import mapValues from 'utils/mapValues';
import pruneObject, { BaseRecord } from 'utils/pruneObject';

const removeEmptyArrays = <T extends BaseRecord>(object: T) =>
  pruneObject(mapValues(object, (value) => (Array.isArray(value) && !value.length ? undefined : value)));

export default removeEmptyArrays;
